export default "__VITE_ASSET__CKQaIS6x__"